import { useStuartMutate } from '../../../../APIs/Hooks/PhpAPIHooks'
import { useParams } from 'react-router-dom'
import { useMessagePopupContext } from '../../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQueryClient } from 'react-query'
import { tsScreenCollection } from '../../../../Typescript/DB_Interface'

export function useAddCollection(
  collection: Partial<tsScreenCollection> | undefined,
  setOpen: any,
) {
  const { screen_id } = useParams()
  const queryClient = useQueryClient()
  const { setMessage } = useMessagePopupContext()

  let path = '/screen/addCollection.php'
  path += `?ScreenID=${screen_id}`
  path += `&Rebill=${collection?.Rebill}`
  path += `&Criteria=${collection?.Criteria}`
  path += `&SampleType=${collection?.SampleType}`
  path += `&Destination=${collection?.DestinationFacilityID}`
  path += `&CriteriaDetails=${collection?.CriteriaDetails}`
  path += `&CollectionInstructions=${encodeURIComponent(collection?.CollectionInstructions ?? '')}`
  path += `&Tests=${collection?.Tests}`
  path += `&SampleSource=${collection?.SampleSourceOther ? collection.SampleSourceOther : collection?.SampleSource}`

  return useStuartMutate(path, async (data) => {
    if (data?.message) {
      setMessage({
        subject: 'Unable to save result comment',
        message: data.message,
        severity: 'warning',
      })
    } else {
      await queryClient.invalidateQueries({
        queryKey: ['PhpAPI', '/stuart', '/screen/getScreenCollections.php'],
      })
      setOpen(false)
    }
  })
}
